import clsx from 'clsx';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { defaultModalStyles } from '@/components/Elements/Modal/customStyles';

import { PaymentsModal } from '../PaymentsModal';

export type WaitProcessModalProps = {
  timeInMS?: number;
  title: string;
  description: string;
  customImage?: string;
  customImageWidth?: string;
  imageClass?: string;
  isOpen?: boolean;
  timeoutCallback?: () => void;
};

export const WaitProcessModal = ({
  timeInMS = 7000,
  title,
  description,
  customImage,
  customImageWidth = '150',
  isOpen = false,
  timeoutCallback,
  imageClass,
}: WaitProcessModalProps) => {
  useEffect(() => {
    if (isOpen && timeInMS > 0) {
      setTimeout(() => {
        timeoutCallback && timeoutCallback();
      }, timeInMS);
    }
  });

  const { t } = useTranslation();

  return (
    <PaymentsModal isOpen={isOpen} closeButton={false} style={defaultModalStyles}>
      {!customImage && (
        <div className="modal__spinner__container">
          <i className="ri-loader-4-fill fa-spin"></i>
        </div>
      )}
      <div className="wait__process__modal__content">
        <h2 className="md__payments__modal__title--h2 text-center">{title}</h2>
        {customImage && customImageWidth && (
          <img
            width={customImageWidth}
            src={customImage}
            alt={t('WaitProcessModal.securityNotice')}
            className={clsx('mb-7 m-auto', imageClass)}
          />
        )}
        <div>
          <p className="md__payments__modal--h5 text-center">{description}</p>
          <p className="md__payments__modal--h5 text-center">{t('Forms.pleaseWait')}</p>
        </div>
      </div>
    </PaymentsModal>
  );
};
